import React from "react";
import { setData } from "rivals/shared/utils/qa";
import { Props } from "./types";

function ApplePodcast({ accountId, podcastId }: Props): React.JSX.Element {
  return (
    <iframe
      allow="autoplay *; encrypted-media *; fullscreen *; clipboard-write"
      height="175"
      sandbox="allow-forms allow-popups allow-same-origin allow-scripts allow-storage-access-by-user-activation allow-top-navigation-by-user-activation"
      src={`https://embed.podcasts.apple.com/us/podcast//id${accountId}?i=${podcastId}&amp;theme=light`}
      style={{
        background: "transparent",
        border: 0,
        maxWidth: "660px",
        overflow: "hidden",
        width: "100%"
      }}
      title={`apple-podcast-embed-${accountId}-${podcastId}`}
      {...setData(`apple-podcast-embed`, `${accountId}-${podcastId}`)}
    ></iframe>
  );
}

export default ApplePodcast;
